module.exports = __webpack_public_path__ + "assets/img/ad3a16a8dcd1dd87f4cc47c8e9249577.png";